
<div mat-dialog-title class="modal-header" title='{{data.title}}'>{{data.title }}</div>
<div mat-dialog-content class="modal-body">
  	<p *ngFor="let paragraph of data.contentParagraphs">
	  {{paragraph}}
	  </p>
	<a [carmRouterLink]="data.link" (click)="closeModal()">{{ data.linkDescription ? data.linkDescription : data.link }}</a>
</div>
<div class="modal-footer">
	<carm-button
		*ngFor="let button of data.buttons"
		[id]="button.id"
		btnLabel="{{ button.label }}"
		[btnTypeDefault]="true"
		[spaceTop]="true"
		[customClass]="button.class"
		(click)="closeModal(button.id)"
	>
	</carm-button>
</div>
